/**
 * services/hire/jobTokenHistory.ts
 * Client for the per-job token-history endpoint
 * (GET /api/hire/v2/requisitions/:id/token-history).
 */
import axiosInstance from '../../api/axiosInstance';
import { HireMatch_Requisition_Token_History_Url } from '../../api/endpoints';
import type { JobTokenHistory } from '../../schemas/hire/jobTokenHistory';

export async function getJobTokenHistory(id: string, signal?: AbortSignal): Promise<JobTokenHistory> {
  const { data } = await axiosInstance.get<JobTokenHistory>(HireMatch_Requisition_Token_History_Url(id), { signal });
  return data;
}
